import { EmailBadge } from "../../styles";
import { Email } from "../../types";
import { Check, X, AlertTriangle } from "lucide-react";

interface BlocoEmailProps {
    email: Email;
}

export default function BlocoEmail({ email }: BlocoEmailProps) {
    const isSucesso = email.status === 'sucesso';
    const isAviso = email.status === 'aviso';

    const badgeStatus = isSucesso ? 'sucesso' : isAviso ? 'aviso' : 'falha';

    return (
        <div className="expanded-section">
            <h4 className="section-title">Email</h4>
            <div className="email-container">
                <EmailBadge status={badgeStatus}>
                    {isSucesso ? (
                        <>
                            <Check className="email-icon" />
                            Enviado com sucesso
                        </>
                    ) : isAviso ? (
                        <>
                            <AlertTriangle className="email-icon" />
                            Email não enviado
                        </>
                    ) : (
                        <>
                            <X className="email-icon" />
                            Falha no envio
                        </>
                    )}
                </EmailBadge>
                {email.detalhes && (
                    <p className="email-detalhes">{email.detalhes}</p>
                )}
            </div>
        </div>
    );
}

